module.exports = __webpack_public_path__ + "img/sv15.a2f7cc57.svg";